<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";

export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_43",
      next: "P_45",
      topic: "Estás en: Taller ¿Qué es crédito? / ¡Quiero conocer el tipo de crédito ideal para mí!",
      progress: false,
      questions: 5
    };
  },
  methods: {
    evaluation() {
      var quiz_prefix = "page1";
      var quiz_results = Object.keys(this.$parent.results)
        .filter(key => key.indexOf(quiz_prefix) > -1)
        .reduce((obj, key) => {
          obj[key] = this.$parent.results[key];
          return obj;
        }, {});
      return (
        (100 / this.questions) *
        Object.values(quiz_results).reduce((a, b) => a + b, 0)
      ).toFixed(0);
    }
  }
};
</script>

<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(:back='last') {{topic}}
              v-card.ml-0.pl-0(flat, text-xs-start)
                v-card-text.titulo36Book.ml-0.pl-0
                  | ¡Bien! Sigue adelante.
                v-card-text.parrafoDestacadoB.ml-0.pl-0.pt-5
                  | La actividad pasada te brindó un panorama general de los principales tipos de crédito, pero lo cierto es que
                  |  cada banco tiene una amplia oferta de productos que incluso engloban beneficios y usos específicos en un sólo crédito.
                  |  ¡Acércate a diferentes instituciones financieras y conoce las oportunidades que te ofrecen! También recuerda que cualquier crédito que solicites estará sujeto a aprobación.
                v-card-text.parrafoDestacadoB.ml-0.pl-0.pt-5
                  | ¡Pulsa el botón y sigue aprendiendo! 
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button ', color='primary ', @click.prevent="nextChapter(next)")
                | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>